import { createAction } from 'redux-actions'

import { apiRequest } from 'helpers/Request'
import processError from '../../helpers/processError'

import * as appActions from './app'
import {
  userSet,
  isLender,
} from './user'
import {
  creditCardSet,
} from './creditcard'
import {
  orderSet,
} from './order'

import { scheduleActions, balanceActions } from '../types'

export const scheduleSet = createAction(scheduleActions.SCHEDULE_SET)
export const balanceSet = createAction(balanceActions.BALANCE_SET)

export function scheduleTokenGet(token) {
  return dispatch => {
    dispatch(appActions.appLoading(true))
    apiRequest({
      // String concat (not a template literal) to avoid an ESLint 7.21
      // template-curly-spacing crash that aborts the lint job once this
      // file is in the MR's changed set (same workaround as order.js).
      endpoint: '/schedule/token/' + token,
      method: 'get',
    }).then(response => {
      dispatch(scheduleSet(response.data.schedule))
      dispatch(userSet({ data: response.data.user }))
      dispatch(isLender({ lender: response.data.lender }))
      dispatch(balanceSet({ balance: response.data.outstanding_balance }))
      dispatch(creditCardSet(response.data.info))
      //      dispatch(initializeDocuments(response.data.evault.documents));
      // payment_method_types (BOTS-29): the borrower payment methods resolved
      // server-side. BorrowerPaymentForm passes it to the Payment Element so
      // the displayed methods match the PaymentIntent's.
      dispatch(orderSet({
        data: {
          ...response.data.order,
          payment_method_types: response.data.payment_method_types,
        },
      }))
      dispatch(appActions.appComponent('steps'))
      dispatch(appActions.appLoading(false))
    })
  }
}

export function scheduleGet(schedule_id) {
  return (dispatch) => {
    dispatch(appActions.appLoading(true))
    apiRequest({
      endpoint: '/schedule',
      method: 'get',
      data: {
        params: {
          id: schedule_id,
        },
      },
    })
      .then((response) => {
        dispatch(scheduleSet(response.data))
        dispatch(appActions.appComponent('steps'))
        dispatch(appActions.appLoading(false))
      })
      .catch((error) => {
        const e = processError(error)
        dispatch(appActions.appErrors(e))
      })
  }
}

export function schedulePayment(schedule_id, data) {
  return (dispatch) => {
    dispatch(appActions.appLoading(true))
    apiRequest({
      // String concat for the same ESLint template-curly-spacing crash as above.
      endpoint: '/schedule/' + schedule_id,
      method: 'put',
      data,
    })
      .then((response) => {
        Promise.resolve(dispatch(scheduleSet(response.data))).then(
          dispatch(appActions.appStepIncrement()),
          dispatch(appActions.appLoading(false)),
        )
      })
      .catch((error) => {
        const e = processError(error)
        Promise.resolve(dispatch(appActions.appErrors(e))).then(appActions.appLoading(false))
      })
  }
}

export function schedulePut(data) {
  return (dispatch) => {
    dispatch(appActions.appLoading(true))
    apiRequest({
      endpoint: '/schedule/consumerTimes',
      method: 'put',
      data,
    })
      .then((response) => {
        Promise.resolve(dispatch(scheduleSet(response.data.schedule))).then(
          dispatch(appActions.appStepIncrement()),
          dispatch(appActions.appLoading(false)),
        )
      })
      .catch((error) => {
        const e = processError(error)
        Promise.resolve(dispatch(appActions.appErrors(e))).then(appActions.appLoading(false))
      })
  }
}

export function scheduleDocuments() {}

export function scheduleUploadDocument() {}
